export const convertNumberToPercent = (num: number) => {
  if (num >= 1) return "100%";
  if (num === 0) return "0";
  let str = Number(num * 100).toFixed();
  str += "%";
  return str;
};

export const numberWithCommas = (number: number) =>
  (number * 1).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
